const state = {
  menuBarWidth: 250, // 菜单栏宽度
  isCollapse: false, // 侧边菜单是否收齐

  routers: [
    {
      id: '1',
      pid: '-1',
      path: '/home',
      name: 'Home',
      href: '/home/index',
      meta: {
        title: '首页',
        isMenu: '1',
        icon: 'menu_home_icon',
        activeIcon: 'menu_home_icon1'
      },
      type: 'menu',
      isCheck: '0',
      children: []
    },
    {
      id: '4',
      pid: '-1',
      path: '',
      name: '',
      href: '',
      meta: {
        title: '工单管理',
        isMenu: '1',
        icon: 'menu_order_icon',
        activeIcon: 'menu_order_icon1'
      },
      type: 'menu',
      children: [
        {
          id: '46',
          pid: '4',
          path: '/workOrder',
          name: 'WorkOrder',
          href: '/workOrder/index',
          meta: {
            title: '我的工单',
            isMenu: '1'
          },
          type: 'router',
          children: [
            {
              id: '37',
              pid: '46',
              name: 'handle-order',
              meta: {
                title: '操作工单'
              },
              type: 'button'
            },
            {
              id: '38',
              pid: '46',
              name: 'del-order',
              meta: {
                title: '撤销工单'
              },
              type: 'button'
            },
            {
              id: '11',
              pid: '46',
              path: '/workOrderDetail',
              name: 'WorkOrderDetail',
              href: '/workOrder/detail',
              meta: {
                title: '工单详情',
                isMenu: '0'
              },
              type: 'router',
              children: [],
              disabled: true
            }
          ]
        },
        {
          id: '47',
          pid: '4',
          path: '/order-draft',
          name: 'OrderDraft',
          href: '/workOrder/order-draft',
          meta: {
            title: '我的草稿',
            isMenu: '1'
          },
          type: 'router',
          children: []
        }
      ]
    },
    {
      id: '2',
      pid: '-1',
      path: '/organization',
      name: 'Organization',
      href: '',
      meta: {
        title: '组织管理',
        isMenu: '1',
        icon: 'home_organization_icon',
        activeIcon: 'home_organization_icon1'
      },
      type: 'menu',
      children: [
        {
          id: '6',
          pid: '2',
          path: '/employees',
          name: 'Employees',
          href: '/organization/employees',
          meta: {
            title: '员工管理',
            isMenu: '1'
          },
          type: 'router',
          children: [
            {
              id: '20',
              pid: '6',
              name: 'update-employees',
              meta: {
                title: '修改员工'
              },
              type: 'button'
            },
            {
              id: '21',
              pid: '6',
              name: 'update-pwd',
              meta: {
                title: '修改密码'
              },
              type: 'button'
            },
            {
              id: '22',
              pid: '6',
              name: 'del-employees',
              meta: {
                title: '删除员工'
              },
              type: 'button'
            },
            {
              id: '23',
              pid: '6',
              name: 'add-employees',
              meta: {
                title: '新增员工'
              },
              type: 'button'
            }
          ]
        },
        {
          id: '7',
          pid: '2',
          path: '/role',
          name: 'Role',
          href: '/organization/role',
          meta: {
            title: '角色管理',
            isMenu: '1'
          },
          type: 'router',
          children: [
            {
              id: '24',
              pid: '7',
              name: 'add-role',
              meta: {
                title: '新增角色'
              },
              type: 'button'
            },
            {
              id: '25',
              pid: '7',
              name: 'update-role',
              meta: {
                title: '编辑角色'
              },
              type: 'button'
            },
            {
              id: '26',
              pid: '7',
              name: 'del-role',
              meta: {
                title: '删除角色'
              },
              type: 'button'
            }
          ]
        },
        {
          id: '8',
          pid: '2',
          path: '/department',
          name: 'Department',
          href: '/organization/department',
          meta: {
            title: '部门管理',
            isMenu: '1'
          },
          type: 'router',
          children: [
            {
              id: '27',
              pid: '8',
              name: 'add-department',
              meta: {
                title: '新增部门'
              },
              type: 'button'
            },
            {
              id: '28',
              pid: '8',
              name: 'update-department',
              meta: {
                title: '编辑部门'
              },
              type: 'button'
            },
            {
              id: '29',
              pid: '8',
              name: 'view-department',
              meta: {
                title: '查看部门'
              },
              type: 'button'
            },
            {
              id: '30',
              pid: '8',
              name: 'del-department',
              meta: {
                title: '删除部门'
              },
              type: 'button'
            },
            {
              id: '31',
              pid: '8',
              name: 'del-user',
              meta: {
                title: '删除部门员工'
              },
              type: 'button'
            }
          ]
        }
      ]
    },
    {
      id: '5',
      pid: '-1',
      path: '/system',
      name: 'System',
      href: '',
      meta: {
        title: '系统设置',
        isMenu: '1',
        icon: 'menu_system_icon',
        activeIcon: 'menu_system_icon1'
      },
      type: 'menu',
      children: [
        {
          id: '19',
          pid: '5',
          path: '/account',
          name: 'Account',
          href: '/system/account',
          meta: {
            title: '账号设置',
            isMenu: '1'
          },
          type: 'menu',
          children: []
        }
      ]
    }
  ]
}

const mutations = {
  setMenuBarWidth(state, data) {
    state.menuBarWidth = data
  },
  setIsCollapse(state, data) {
    state.isCollapse = data
    state.menuBarWidth = data ? 64 : 250
  }
}

export default {
  namespaced: true,
  state,
  mutations
}
